@if (!mixedMode()) {
<ai-headlines class="block mb-4"></ai-headlines> 

<div class="w-full mb-4 mx-auto text-start">
  <header class="flex flex-col justify-between gap-4 [@media(max-height:607px)]:gap-2 lg:flex-row lg:items-center">
    <h2 class="text-xl lg:text-2xl [@media(max-height:712px)]:text-xl font-bold text-slate-800 dark:text-white whitespace-nowrap">
        Contracts Report
    </h2> 

    <div class="flex flex-wrap items-center gap-3 w-full justify-end">  
          <app-date-picker 
            (valueChange)="rangeValues($event)"
            (dateRangeChange)="onDateRangeChange($event)">
          </app-date-picker>
          @if (productConfig().productServerName == 'credee') {
          <div class="w-[250px]">
            <app-dropdown [options]="currencyOptions" [ngModel]="selectedCurrency()"
              (ngModelChange)="selectedCurrency.set($any($event))" [placeholder]="'Currency'" [selectionMode]="'single'"
              [selectionStyle]="'none'" [type]="'selection'" [maxHeight]="'240px'" [size]="'md'">
            </app-dropdown>
          </div>
          }

        <button
          type="button"
          (click)="openCustomizeLayout()"
          class="flex items-center gap-1.5 px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium hover:border-[#AD46FF]/60 hover:text-[#AD46FF] transition-all duration-200 shadow-sm whitespace-nowrap">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/></svg>
          Customize layout
        </button>
    </div>
  </header>
</div>
}

@if (productConfig(); as config) {
<!-- Customizable 12-col grid.
     Cards are rendered in the persisted order with the persisted col-span;
     visibility, width, and order are all controlled from the Customize
     Layout popup and applied via `applyLayoutEditor()`. The default layout
     stacks every section at 12/12 — visually identical to the original
     full-width design before this customization layer existed. -->
<div [class]="mixedMode() ? 'unified-tile-body' : ''">
<div class="grid grid-cols-12 gap-4 mt-5 grid-flow-row-dense items-stretch" [class.mt-0]="mixedMode()">
    @for (sec of embeddedVisibleSections(); track trackSection($index, sec)) {
    <div [ngClass]="getSectionColClass(sec)" class="group relative h-full min-h-0 flex flex-col">

        @if (!mixedMode()) {
        <!-- Pin to Custom Dashboard quick action.
             Floats above the card content (z-20) and only becomes visible
             on hover/focus so it never overlaps the card's own title or
             chart UI when at rest. Pinned state stays "always on" with a
             check + green pill so the user can tell at a glance which
             sections are already on their dashboard. -->
        <button
          type="button"
          (click)="addToCustomDashboard(sec); $event.stopPropagation()"
          [disabled]="isAddingToCustomDashboard(sec)"
          class="group/pin absolute cursor-pointer top-2 right-2 z-20 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
          [ngClass]="isAddedToCustomDashboard(sec)
            ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
            : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
          [attr.aria-label]="isAddedToCustomDashboard(sec) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
          [title]="isAddedToCustomDashboard(sec) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
          @if (isAddingToCustomDashboard(sec)) {
            <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
            </svg>
            <span>{{ isAddedToCustomDashboard(sec) ? 'Removing' : 'Adding' }}&hellip;</span>
          } @else if (isAddedToCustomDashboard(sec)) {
            <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 6 9 17l-5-5"/>
            </svg>
            <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14"/>
            </svg>
            <span class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove from Custom Dashboard</span>
          } @else {
            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14"/><path d="M12 5v14"/>
            </svg>
            <span class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin to Custom Dashboard</span>
          }
        </button>
        }

        @switch (sec.id) {

          <!-- Contract Count Stats -->
          @case (SectionId.CONTRACT_COUNT_STATS) {
            <app-contract-count-stats
              [dateRange]="dateRange"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-contract-count-stats>
          }

          <!-- Contract Status -->
          @case (SectionId.CONTRACT_STATUS) {
            <app-contract-status
              [dateRange]="dateRange"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-contract-status>
          }

          <!-- State Contracts -->
          @case (SectionId.STATE_CONTRACTS) {
            <app-state-contracts
              [dateRange]="dateRange"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-state-contracts>
          }

          <!--
            Platform / Contract cards are flattened into one customizable
            slot per underlying card, so the Customize Layout popup mirrors
            the visible dashboard 1:1. Each `<app-payment-collection-cards>`
            instance receives `[onlyKeys]` to render + fetch only its own
            card from `platformKeys` / `contractKeys` (default behavior is
            preserved when `onlyKeys` is omitted elsewhere).
          -->

          <!-- Top Contracts Platforms (cardType 2) -->
          @case (SectionId.PLATFORM_TOP_CONTRACTS_PLATFORMS) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: platformKeys,
                headers: platformHeaders,
                datePickerParams: dateRange,
                cols: 'grid-cols-2',
                valueKey: 'value'
              }"
              [onlyKeys]="['platform_contracts']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Average Contract Value (cardType 3) -->
          @case (SectionId.PLATFORM_AVERAGE_CONTRACT_VALUE) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: platformKeys,
                headers: platformHeaders,
                datePickerParams: dateRange,
                cols: 'grid-cols-2',
                valueKey: 'value'
              }"
              [onlyKeys]="['average_financed_recurring']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Enrollment Collected -->
          @case (SectionId.CONTRACT_ENROLLMENT_COLLECTED) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['enrollment_collection']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Upfront Collected -->
          @case (SectionId.CONTRACT_UPFRONT_COLLECTED) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['upfront_collection']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Late Fee Collected -->
          @case (SectionId.CONTRACT_LATE_FEE_COLLECTED) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['late_fee_collection']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Change Payment Date Fee Collected -->
          @case (SectionId.CONTRACT_CHANGE_PAYMENT_DATE) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['change_payment_date_collection']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Downpayment Collected -->
          @case (SectionId.CONTRACT_DOWNPAYMENT_COLLECTED) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['downpayment_collection']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Edit Contract -->
          @case (SectionId.CONTRACT_EDIT_CONTRACT) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['contract_edit_records']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Reversals -->
          @case (SectionId.CONTRACT_REVERSALS) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['reversals']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Refunds -->
          @case (SectionId.CONTRACT_REFUNDS) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['refunds']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Late Fee Refunded -->
          @case (SectionId.CONTRACT_LATE_FEE_REFUNDED) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['late_fee_refunded']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Settled Contracts -->
          @case (SectionId.CONTRACT_SETTLED_CONTRACTS) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['settled_contracts']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Contract State -->
          @case (SectionId.CONTRACT_STATE) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['contract_stats_new_1']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Protected Status Pending -->
          @case (SectionId.CONTRACT_PROTECTED_PENDING) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['fetch_protected_pending_contracts']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Protected Contracts -->
          @case (SectionId.CONTRACT_PROTECTED_CONTRACTS) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['fetch_protected_marked_contracts']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

          <!-- Non-protected Contracts -->
          @case (SectionId.CONTRACT_NON_PROTECTED_CONTRACTS) {
            <app-payment-collection-cards
              [config]="{
                selectedContractType: selectedContractType,
                cards: contractKeys,
                datePickerParams: dateRange
              }"
              [onlyKeys]="['fetch_nonProtected_marked_contracts']"
              [productServerName]="config.productServerName"
              [requiresAccessToken]="config.requiresAccessToken"
              [cocu_id]="selectedCurrencyInfo().cocu_id"
              [country_id]="selectedCurrencyInfo().country_id">
            </app-payment-collection-cards>
          }

        }
    </div>
    }
</div>
</div>
}

<!--  Customize Popup Layout — Mini-Dashboard Editor.
      Inline overlay that visually mirrors the actual contracts report
      sections. Tiles support drag-drop reordering, width resizing
      (4 / 6 / 8 / 12 chips), and visibility toggling — applied to the
      live page when the user hits Apply. -->
<!-- ═════════════════════════════════════════════════════════════════════════ -->
@if (isLayoutEditorOpen()) {
<!-- z-[10010] sits above the global navbar/sidebar (which use z-[999]) so the popup never gets clipped by the dashboard header. Extra top padding gives breathing room from the page top. -->
<div
  appLayoutEditorOverlay
  class="fixed inset-0 z-[10010] flex items-center justify-center p-3 sm:p-6 bg-slate-900/60 backdrop-blur-sm animate-fadeIn overflow-hidden"
  (click)="closeLayoutEditor()">

  <div
    class="layout-editor-popup relative w-full max-w-[1100px] max-h-[min(88vh,calc(100vh-2rem))] flex flex-col bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-700 overflow-hidden"
    (click)="$event.stopPropagation()">

    <!--  Header -->
    <div
      class="flex flex-wrap items-center justify-between gap-3 px-5 sm:px-6 py-4 border-b border-slate-200 dark:border-slate-700 bg-gradient-to-r from-[#AD46FF]/5 via-white to-[#AD46FF]/5 dark:from-purple-500/10 dark:via-slate-900 dark:to-purple-500/10">
      <div class="flex items-center gap-3 min-w-0">
        <div
          class="w-10 h-10 rounded-xl bg-gradient-to-br from-[#AD46FF] to-[#7c3aed] flex items-center justify-center shadow-lg shadow-[#AD46FF]/30 shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white"
            stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <rect width="7" height="9" x="3" y="3" rx="1" />
            <rect width="7" height="5" x="14" y="3" rx="1" />
            <rect width="7" height="9" x="14" y="12" rx="1" />
            <rect width="7" height="5" x="3" y="16" rx="1" />
          </svg>
        </div>
        <div class="min-w-0">
          <h2 class="text-lg sm:text-xl font-semibold text-[#141437] dark:text-white truncate">
            Customize Layout
          </h2>
          <p class="text-[11px] text-violet-700 dark:text-violet-300">
            <b>Drag</b> a card to reorder &middot; click the <b>width chips</b> to resize &middot; toggle the <b>eye</b> to hide/show &middot; the preview mirrors the real dashboard.
          </p>
        </div>
      </div>

      <div class="flex items-center gap-2.5 flex-wrap">
        <!-- Auto Adjust Width: expands the smallest card in each row of
             the preview so any leftover columns are filled. -->
        <button
          type="button"
          (click)="autoAdjustEditorWidths()"
          [disabled]="!canAutoAdjustEditorWidths()"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all"
          [ngClass]="canAutoAdjustEditorWidths()
            ? 'bg-white dark:bg-slate-800 text-[#AD46FF] border border-[#AD46FF]/30 hover:bg-violet-50 dark:hover:bg-white/5 hover:border-[#AD46FF]/60 shadow-sm cursor-pointer'
            : 'bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 border border-slate-200 dark:border-slate-700 cursor-not-allowed'"
          title="Expand the smallest card in each row to fill the leftover columns">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 3 21 3 21 9"/>
            <polyline points="9 21 3 21 3 15"/>
            <line x1="21" y1="3" x2="14" y2="10"/>
            <line x1="3" y1="21" x2="10" y2="14"/>
          </svg>
          Auto Adjust Width
        </button>

        <!-- Visible count chip -->
        <span
          class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-violet-50 dark:bg-violet-500/10 text-[#AD46FF] border border-[#AD46FF]/20">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
          {{ editorVisibleCount() }} / {{ editorItems().length }} visible
        </span>

        <!-- Close -->
        <button
          type="button"
          (click)="closeLayoutEditor()"
          class="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
          title="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Layout Preview Area (mini dashboard editor) -->
    <div class="flex-1 overflow-y-auto custom-scroll bg-[#FAFAFE] dark:bg-slate-950/40 p-3 sm:p-4">

      <!-- 12-col mini grid: cdkDropList enables drag-drop reordering;
           tile widths come from `getEditorColSpanClass(item.colSpan)`. -->
      <div
        cdkDropList
        cdkDropListOrientation="mixed"
        (cdkDropListDropped)="onEditorCardDrop($event)"
        class="grid grid-cols-12 gap-2 sm:gap-2.5 grid-flow-row-dense">

        @for (item of editorItems(); track trackEditorItem($index, item)) {
        <div
          cdkDrag
          cdkDragBoundary=".layout-editor-popup"
          [cdkDragData]="item"
          [cdkDragDisabled]="!item.visible"
          [ngClass]="[
            getEditorColSpanClass(item.colSpan),
            item.visible
              ? 'border-slate-200 dark:border-slate-700 shadow-sm hover:shadow-lg hover:-translate-y-0.5 hover:border-[#AD46FF]/40 cursor-grab active:cursor-grabbing'
              : 'border-dashed border-slate-300 dark:border-slate-600 opacity-60 cursor-not-allowed'
          ]"
          class="layout-editor-tile group relative rounded-xl border bg-white dark:bg-slate-800 transition-all duration-200 overflow-hidden">

          <!-- Drop placeholder (highlight slot during drag) -->
          <div
            *cdkDragPlaceholder
            [ngClass]="getEditorColSpanClass(item.colSpan)"
            class="rounded-xl border-2 border-dashed border-[#AD46FF]/60 bg-violet-50 dark:bg-violet-500/10 min-h-[88px]">
          </div>

          <!-- Tile header: drag handle + title + visibility toggle -->
          <div class="flex items-start justify-between gap-2 px-2.5 pt-2 pb-1">
            <div class="flex items-center gap-1.5 min-w-0">
              <span
                class="text-slate-300 dark:text-slate-600 group-hover:text-[#AD46FF] transition-colors shrink-0"
                title="Drag to reorder">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                  <circle cx="9" cy="5" r="1" />
                  <circle cx="9" cy="12" r="1" />
                  <circle cx="9" cy="19" r="1" />
                  <circle cx="15" cy="5" r="1" />
                  <circle cx="15" cy="12" r="1" />
                  <circle cx="15" cy="19" r="1" />
                </svg>
              </span>
              <span
                class="text-[11px] sm:text-[12px] font-semibold text-[#141437] dark:text-white truncate"
                [title]="item.title">
                {{ item.title }}
              </span>
            </div>

            <!-- Visibility toggle -->
            <button
              type="button"
              (click)="toggleEditorCardVisibility(item.id); $event.stopPropagation()"
              class="p-1 rounded-md transition-colors shrink-0"
              [ngClass]="item.visible
                  ? 'text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                  : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700'"
              [title]="item.visible ? 'Hide section' : 'Show section'">
              @if (item.visible) {
                <app-icon-v2 name="eye" [size]="14"></app-icon-v2>
              } @else {
                <app-icon-v2 name="eye-off" [size]="14"></app-icon-v2>
              }
            </button>
          </div>

          <!-- Tile body: scaled-down preview placeholder + width chips. -->
          <div class="px-2.5 pb-2">
            <div
              class="rounded-lg bg-gradient-to-br from-violet-50 via-white to-violet-50/50 dark:from-violet-500/10 dark:via-slate-800 dark:to-violet-500/5 border border-slate-100 dark:border-slate-700/50 h-10 sm:h-10 flex items-center justify-center mb-1.5 overflow-hidden relative">
              <!-- abstract preview bars -->
              <div class="flex items-end gap-1 w-2/3 h-1/2 opacity-70">
                <span class="flex-1 bg-[#AD46FF]/30 rounded-sm" style="height: 40%"></span>
                <span class="flex-1 bg-[#AD46FF]/50 rounded-sm" style="height: 70%"></span>
                <span class="flex-1 bg-[#AD46FF]/40 rounded-sm" style="height: 55%"></span>
                <span class="flex-1 bg-[#AD46FF]/60 rounded-sm" style="height: 90%"></span>
                <span class="flex-1 bg-[#AD46FF]/35 rounded-sm" style="height: 50%"></span>
                <span class="flex-1 bg-[#AD46FF]/55 rounded-sm" style="height: 80%"></span>
              </div>
              <span
                class="absolute top-0.5 right-1 text-[9px] font-semibold text-[#AD46FF]/70 uppercase tracking-wider">
                {{ item.colSpan }}/12
              </span>
            </div>
            <!-- Width selector — minimize-2 / maximize-2 icon buttons step
                 the card through [4 → 6 → 8 → 12] widths.
                 Buttons disable themselves at the boundary. -->
            <div class="flex items-center gap-1.5">
              <span class="text-[10px] font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wide mr-0.5">Width</span>

              <!-- Decrease (minimize-2) -->
              <button
                type="button"
                (click)="decreaseEditorCardColSpan(item.id); $event.stopPropagation()"
                [disabled]="!canDecreaseEditorCardColSpan(item)"
                class="p-1 rounded-md border transition-all"
                [ngClass]="canDecreaseEditorCardColSpan(item)
                  ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                  : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'"
                title="Decrease width">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="4 14 10 14 10 20" />
                  <polyline points="20 10 14 10 14 4" />
                  <line x1="14" y1="10" x2="21" y2="3" />
                  <line x1="3" y1="21" x2="10" y2="14" />
                </svg>
              </button>

              <!-- Current width pill — Small / Medium / Large / Full -->
              <span
                class="inline-flex items-center justify-center min-w-[58px] h-[20px] px-2 rounded-md text-[10px] font-semibold bg-[#AD46FF]/10 text-[#AD46FF] border border-[#AD46FF]/20 select-none whitespace-nowrap">
                {{ getEditorColSpanLabel(item.colSpan) }}
              </span>

              <!-- Increase (maximize-2) -->
              <button
                type="button"
                (click)="increaseEditorCardColSpan(item.id); $event.stopPropagation()"
                [disabled]="!canIncreaseEditorCardColSpan(item)"
                class="p-1 rounded-md border transition-all"
                [ngClass]="canIncreaseEditorCardColSpan(item)
                  ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                  : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'"
                title="Increase width">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="15 3 21 3 21 9" />
                  <polyline points="9 21 3 21 3 15" />
                  <line x1="21" y1="3" x2="14" y2="10" />
                  <line x1="3" y1="21" x2="10" y2="14" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        }
      </div>

      @if (editorItems().length === 0) {
      <div class="text-center py-16 text-slate-500 dark:text-slate-400">
        <p class="text-sm">No layout items to customize.</p>
      </div>
      }
    </div>

    <!-- Footer -->
    <div
      class="flex items-center justify-between gap-3 px-5 sm:px-6 py-3.5 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
      <button
        type="button"
        (click)="resetLayoutEditorToDefaults()"
        class="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
          <path d="M3 3v5h5" />
        </svg>
        Set Default
      </button>

      <div class="flex items-center gap-2">
        <button
          type="button"
          (click)="closeLayoutEditor()"
          class="px-4 py-2 rounded-lg text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors">
          Cancel
        </button>
        <button
          type="button"
          (click)="applyLayoutEditor()"
          [disabled]="editorVisibleCount() === 0"
          class="px-5 py-2 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-[#AD46FF] to-[#7c3aed] hover:shadow-lg hover:shadow-[#AD46FF]/30 hover:-translate-y-px disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 transition-all">
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
}
